import styled from 'styled-components';

export const StyledPrivacyPolicyCheckMarkWrapper = styled.div`
    background: #0B93E314;
    padding: 24px;
    border-radius: 50%;
    margin-bottom: 20px;
`;

export const StyledPrivacyPolicyTitle = styled.div`
    font-size: 24px;
    font-weight: 700;
    line-height: 130%;
    text-align: center;
    color: ${({ theme }) => theme.fontColors.primary};
    margin-bottom: 20px;
`;

export const StyledPrivacyPolicyDescription = styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    color: ${({ theme }) => theme.fontColors.darkGrey};

    &.spacing {
        margin-bottom: 20px;
    }

    & a {
        color: #0b93e3;
        text-decoration: underline;
    }

    & span {
        font-weight: 500;
        color: ${({ theme }) => theme.fontColors.darkGrey};
    }
`;